import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/payment`;

export default {
  async getErrorCause(paymentId) {
    let apiUrl = store.state.countrySelected.api;
    let params = {
      lang: store.state.langSelected.langWsp,
      id: paymentId
    };
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/getErrorCause`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async getShouldRetry(paymentId) {
    let apiUrl = store.state.countrySelected.api;
    let params = {
      lang: store.state.langSelected.langWsp,
      id: paymentId
    };
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/getIsRetriable`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
